import request from '@/utils/request';

// 数据看板-获取交易总额，总交易笔数，周环比，日环比 http://yapi.lepass.cn/project/339/interface/api/255981
export function getTotalTransaction(params) {
  return request({
    url: '/merchant/boardData/getTotalTransaction',
    method: 'get',
    params,
  });
}

// 数据看板-获取折现图统计数据 http://yapi.lepass.cn/project/339/interface/api/255989
export function getBrokenLineChart(params) {
  return request({
    url: '/merchant/boardData/brokenLineChart',
    method: 'get',
    params,
  });
}

// 数据看板-交易渠道分布统计 http://yapi.lepass.cn/project/339/interface/api/255997
export function getTransChannelData(params) {
  return request({
    url: '/merchant/boardData/transChannelData',
    method: 'get',
    params,
  });
}

// 查询大客首单交易时间 http://yapi.lepass.cn/project/339/interface/api/265301
export function getFirstOrderTime(params) {
  return request({
    url: '/merchant/boardData/getFirstOrderTime',
    method: 'get',
    params,
  });
}

// 收益提现-统计订单数，累计收益，已提现，待提现，提现中 http://yapi.lepass.cn/project/339/interface/api/256005
export function statisticsProfit(params) {
  return request({
    url: '/merchant/profit/statisticsProfit',
    method: 'get',
    params,
  });
}

// 收益提现-获取收益明细 http://yapi.lepass.cn/project/339/interface/api/256013
export function getProfitDetail(data) {
  return request({
    url: '/merchant/profit/getProfitDetail',
    method: 'post',
    data,
  });
}

// 收益提现-获取开票寄送信息 http://yapi.lepass.cn/project/339/interface/api/256021
export function getSendAndInvoiceInfo(params) {
  return request({
    url: '/merchant/profit/getSendAndInvoiceInfo',
    method: 'get',
    params,
  });
}

// 收益提现-提现 http://yapi.lepass.cn/project/339/interface/api/256029
export function getExtract(data) {
  return request({
    url: 'merchant/profit/extract',
    method: 'post',
    data,
  });
}

// 上传发票图片 http://yapi.lepass.cn/project/339/interface/api/261101
export function uploadMerchantPicture(data) {
  return request({
    url: 'merchant/profit/uploadMerchantPicture',
    method: 'post',
    data,
  });
}
